import * as React from 'react';

import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';

import { ReactComponent as LoaderMd } from './assets/loader-md.svg';

import * as cs from './Loader.module.css';

const Loader = ({ ...restProps }) => (
  <div role="status" {...restProps}>
    <VisuallyHidden>Loading</VisuallyHidden>
    <LoaderMd className={cs.loader} aria-hidden />
  </div>
);

export { Loader };
